import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Link } from "react-router-dom";

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import { Grid } from "@material-ui/core";

// Forms
import ActionSubmitForm from "components/Forms/ActionSubmitForm.jsx"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore, setFirstAction } from "store/actions/actionsActions"
import FlightSearchForm from "../../components/Forms/FlightSearchForm";
import { textAlign } from "@material-ui/system";

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      updateActionModal: false,
      editActionID: "",
      editActionTitle: "",
    };
  }

  handleClickOpen = (modal, actionID, actionTitle) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      editActionID: actionID,
      editActionTitle: actionTitle
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  getFlight = (flightNumber) => {
    const axios = require("axios");  
    console.log("getting flight infio")
    axios({
      "method": "GET",
      "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/${flightNumber}`,
      "headers": {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
        "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
      }, "params": {
        "withLocation": "true",
        "withAircraftImage": "true"
      }
    })
      .then((response) => {
        this.setState({
          flightData: response.data,
          flightDataLoaded: true
        });
      })
      .catch((error) => {
        console.log(error)
      })

  }

  handleChange = (docID) => {
    console.log(docID)
  }

  render() {
    const { AuthBool, classes } = this.props;

    // Format and upload data to firestore
    // updateFirestoreWithTableData('TEST-actions-list',(tableToFirestoreObjects(this.props.actionsData)))
    // updateFirestoreWithTableData('TEST-users',(tableToFirestoreObjects(this.props.users)))

    // // add uid to firestore documents
    // if(this.state.dataLoaded === true){
    //   this.props.actionsData.dataRows.map(row => addFieldToDocument(row[0], {volUID: "TestID"}))
    // }    

    if (AuthBool) {
      if (this.props.actionsData.dataLoaded
        && this.props.users.dataLoaded
        && !this.state.dataLoaded) {
        // this.loadData()
      }
    }

    if (!this.state.flightDataLoaded) {
      this.getFlight(this.props.id)
    }

    let flight = {}

    if (this.state.flightDataLoaded) {
      flight = this.state.flightData
      console.log(flight)
    }

    return (
      <div>
        {
          this.state.flightDataLoaded ? (
            <div>
              <GridContainer>
                <GridItem xs={12} md={3}>
                  {flight[0].aircraft.image && <img src={flight[0].aircraft.image.url} style={{ maxWidth: "250px" }}></img>}
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h1>{flight[0].number}</h1>
                  <h3>{flight[0].airline.name} / {flight[0].aircraft.model}</h3>
                  <a href={"https://www.google.com/search?q="+flight[0].number} target="_blank"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/235px-Google_%22G%22_Logo.svg.png" style={{maxWidth: "25px"}}></img></a>
                </GridItem>
                <GridItem xs={12} md={3}>
                  <br />
                  <h1 style={{ textAlign: "center" }}>{flight[0].status}</h1>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h1 style={{ textAlign: "center" }}>Departure</h1>
                  <h1 style={{ textAlign: "center" }}>{flight[0].departure.airport.iata}</h1>
                  <h4 style={{ textAlign: "center" }}>{flight[0].departure.airport.name}</h4>
                  <h3 style={{ textAlign: "center" }}>{flight[0].departure.scheduledTimeLocal.slice(0, -12)}</h3>
                  <h1 style={{ textAlign: "center" }}><b>{flight[0].departure.scheduledTimeLocal.slice(10, -6)}</b></h1>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h1 style={{ textAlign: "center" }}>Arrival</h1>
                  <h1 style={{ textAlign: "center" }}>{flight[0].arrival.airport.iata}</h1>
                  <h4 style={{ textAlign: "center" }}>{flight[0].arrival.airport.name}</h4>
                  <h3 style={{ textAlign: "center" }}>{flight[0].arrival.scheduledTimeLocal.slice(0, -12)}</h3>
                  <h1 style={{ textAlign: "center" }}><b>{flight[0].arrival.scheduledTimeLocal.slice(10, -6)}</b></h1>
                </GridItem>
              </GridContainer>

              {flight[1] &&
                <GridContainer>
                  <GridItem xs={12} md={6}>
                    <h1 style={{ textAlign: "center" }}>Departure</h1>
                    <h1 style={{ textAlign: "center" }}>{flight[1].departure.airport.iata}</h1>
                    <h4 style={{ textAlign: "center" }}>{flight[1].departure.airport.name}</h4>
                    <h3 style={{ textAlign: "center" }}>{flight[1].departure.scheduledTimeLocal.slice(0, -12)}</h3>
                    <h1 style={{ textAlign: "center" }}><b>{flight[1].departure.scheduledTimeLocal.slice(10, -6)}</b></h1>
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <h1 style={{ textAlign: "center" }}>Arrival</h1>
                    <h1 style={{ textAlign: "center" }}>{flight[1].arrival.airport.iata}</h1>
                    <h4 style={{ textAlign: "center" }}>{flight[1].arrival.airport.name}</h4>
                    <h3 style={{ textAlign: "center" }}>{flight[1].arrival.scheduledTimeLocal.slice(0, -12)}</h3>
                    <h1 style={{ textAlign: "center" }}><b>{flight[1].arrival.scheduledTimeLocal.slice(10, -6)}</b></h1>

                  </GridItem>
                </GridContainer>
              }

            </div>
          ) : (
              <p className={classes.cardSubtitle}>Loading...</p>
            )
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    actionsData: state.actions.actions,
    users: state.actions.users,
    authUser: state.auth.user,
    user: state.profile.user,
    id: ownProps.match.params.id
  }
}

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Orders);



// WEBPACK FOOTER //
// ./src/views/Flights/Flights.jsx